import React, { useMemo, useState , useNavigate } from "react";
import axios from "axios";
import Costanti from '../constantiX';
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column, InputText,Dialog,FileUpload,InputTextarea,Toast,Dropdown, RadioButton  } from "primereact";
import QRCode from "react-qr-code";
import { Formik } from 'formik';
import * as Yup from 'yup';
import ReactGA from 'react-ga4';
import Moment from 'moment';

import "../assets/css/badge.css";

class Supporto extends React.Component {

    constructor() {
        super();
        
        this.actions =[];
      
        
        this.state = {
            activePage:0,
            lista:[],
            totalRecords:0,
            first:0,
            rows:10,
            loading:true,
            visible1:false,
       };
     
       this.token=sessionStorage.getItem("ICEtoken");
       this.utente=JSON.parse(sessionStorage.getItem("utente"));
       this.state = { xcarica:'sezione', imgsrc:'', dati:[], activePage:1, totalRecords:0, pageSize:10, first:0, visible2: false,visible3: false , singolo:{},
       listaoggetto: [
        {oggetto: 'Autenticazione'},
        {oggetto: 'Gestione Azienda'},
        {oggetto: 'Gestione Notarizzazione'},
        {oggetto: 'Altro'},
        
        ]};
       this.onPage = this.onPage.bind(this);
       this.prodottoid=0;
       this.certificatoid=0;
       this.incarico=false;
       this.assegnatecnico=false;
       this.risolto=false;
       this.accetta=false;
       this.riapri=false;
       

       if(this.utente.ruoloid=='1'|| this.utente.ruoloid=='2'){
        this.actions.push({ id:2,
            icon: "pi-pencil",
            label: "",
            action: (id) => {this.vai(id,'U'); console.log("Update "+id)}
        })
     }
        else
        {   this.actions.push({
            id:1,
            icon: "pi-search",
            label: "",
            action: (id) => {this.vai(id,'V'); console.log("View "+id)}
        })
     
        }
        
       

    }
  
    settaImg(){
        var testo=Costanti.UrlCallApi+'file/get/'+this.utente.aziendaid+'/certificato/'+this.certificatoid+'?'+Math.random();
        this.setState({imgsrc:testo})  
      
    }
  
    showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){icona='pi pi-times-circle';}
        if(tipo=='info'){icona='pipi-info-circle';}
        if(tipo=='success'){icona='pi pi-check-circle';}
        if(tipo=='warning'){icona='pi pi-exclamation-triangle';}
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }
  
     componentDidMount() {
        if(this.props.location)
        ReactGA.send({ hitType: "pageview", page:this.props.location.pathname});
        this.prodottoid=(this.props.prodottoid?this.props.prodottoid:-1);
        this.caricaDati(1,this.state.pageSize);  
        
    }
  

    caricaDati(pagina,numrec){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({loading:true});
         var quer='page='+pagina+'&num='+numrec+'&idcollegato='+this.prodottoid+'&tipo=1';
        axios.get(Costanti.UrlCallApi+"supporto/all?"+quer,config)
        .then(res => {
            res.data.lista1.forEach(element => {
                element.azioni=this.actions
            });
            this.setState({dati:res.data.lista1,totalRecords:res.data.conta1,loading:false})
            
            //alert(JSON.stringify(this.state.prodotti))
           }).catch(error=> {
             alert(error)
        });
    } 

    caricaSingolo(id){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({loading:true});
         axios.get(Costanti.UrlCallApi+"supporto/"+id,config)
        .then(res => {
            this.setState({singolo:res.data,loading:false})
            this.certificatoid=id;
            //alert(JSON.stringify(this.state.prodotti))
            //this.settaImg();
           }).catch(error=> {
             alert(error);
             this.certificatoid=0;
        });

      
    } 

 
    salva(values){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
        this.setState({isSubmitting:true});

        if(this.incarico){
            if(this.utente.ruoloid==2)
            values.status='2';
            else
            values.status='1';
            values.ownerid=this.utente.id;
            axios.post(Costanti.UrlCallApi+"supporto/salva/"+this.state.singolo.id,values,config)
            .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
            }).catch(error=> {
                this.showMessage('error','Errore nel salvataggio',error.message);
            this.setState({isSubmitting:false});
        });
        this.caricaSingolo(this.state.singolo.id);
        }else
        if(this.assegnatecnico){
            values.status='1';
            values.ownerid=null;
            axios.post(Costanti.UrlCallApi+"supporto/salva/"+this.state.singolo.id,values,config)
            .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
            }).catch(error=> {
                this.showMessage('error','Errore nel salvataggio',error.message);
            this.setState({isSubmitting:false});
        });

        this.caricaSingolo(this.state.singolo.id);
        }else
        if(this.accetta){
            values.status='A';
            axios.post(Costanti.UrlCallApi+"supporto/salva/"+this.state.singolo.id,values,config)
            .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
            }).catch(error=> {
                this.showMessage('error','Errore nel salvataggio',error.message);
            this.setState({isSubmitting:false});
        });

        this.caricaSingolo(this.state.singolo.id);
        }else  if(this.risolto){
            values.status='C';
            values.ownerid=null;
            axios.post(Costanti.UrlCallApi+"supporto/salva/"+this.state.singolo.id,values,config)
            .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
            }).catch(error=> {
                this.showMessage('error','Errore nel salvataggio',error.message);
            this.setState({isSubmitting:false});
        });

        this.caricaSingolo(this.state.singolo.id);
        }else  if(this.riapri){
            values.status='R';
            values.ownerid=null;
            axios.post(Costanti.UrlCallApi+"supporto/salva/"+this.state.singolo.id,values,config)
            .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
            }).catch(error=> {
                this.showMessage('error','Errore nel salvataggio',error.message);
            this.setState({isSubmitting:false});
        });

        this.caricaSingolo(this.state.singolo.id);
        }else
   
     
        if(this.state.tipo=='U'){  
           axios.post(Costanti.UrlCallApi+"supporto/salva/"+this.state.singolo.id,values,config)
                .then(res => {
                this.showMessage('success','Dati salvati correttamente','');
                this.setState({isSubmitting:false});
                }).catch(error=> {
                    this.showMessage('error','Errore nel salvataggio',error.message);
                this.setState({isSubmitting:false});
            });
        }else

        if(this.state.tipo=='D'){  
            values.status='E';
            axios.post(Costanti.UrlCallApi+"supporto/elimina/"+this.state.singolo.id,values,config)
                 .then(res => {
                 this.showMessage('success','Dati salvati correttamente','');
                 this.setState({isSubmitting:false});
                 setTimeout(() =>  this.setVisible1(false), 1000);
                 }).catch(error=> {
                     this.showMessage('error','Errore nel salvataggio',error.message);
                 this.setState({isSubmitting:false});
                 
             });
         }else
        if(this.state.tipo=='A'){  
            var dato={
            datains: null,
            id: 0,
            oggetto:values.oggetto,
            descrizione:values.descrizione,
            dettagli:values.dettagli,
            tipo:1,
            aziendaid:this.utente.aziendaid,
            idcollegato:-1,
            uteins: this.utente.id,
            status:' '
            }
            axios.post(Costanti.UrlCallApi+"supporto/aggiungi",dato,config)
                 .then(res => {
                 this.showMessage('success','Dati salvati correttamente','');
                 this.setState({isSubmitting:false});
                 setTimeout(() =>  this.setVisible1(false), 1000);
                 }).catch(error=> {
                     this.showMessage('error','Errore nel salvataggio',error.message);
                 this.setState({isSubmitting:false});
             });
         }
         this.incarico=false;
         this.assegnatecnico=false;
         this.risolto=false;
         this.accetta=false;
         this.riapri=false;
         this.setVisible1(false);
    
    
    }

    setVisible1(val){
        this.setState({visible1:val});
        this.caricaDati(this.state.activePage,this.state.pageSize);
        this.setState({singolo:{}});
    }



    vai(id,tipo){
        this.caricaSingolo(id);
        this.setVisible1(true);
        this.setState({tipo:tipo});
        switch(tipo){
            case 'A':this.setState({editMode:true,singolo:{},intestazione:'Aggiungi Richiesta'});break;
            case 'V':this.setState({intestazione:'Visualizza Richiesta'});break;
            case 'D':this.setState({intestazione:'Elimina Richiesta'});break;
            case 'U':this.setState({editMode:true,intestazione:'Modifica Richiesta'});break;
        }


    }
    onPage(event) {
        this.setState({
            loading: true,
            activePage:(event.page+1),
            first:event.first
       });
       this.caricaDati((event.page+1),this.state.pageSize)
    }
    
  

    render() {
    return (
        <div>
                  <Toast ref={(el) => this.toastBC = el} position="bottom-center" />


        <DataTable value={this.state.dati} 
        rows={this.state.pageSize} totalRecords={this.state.totalRecords}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
        paginator={true} onPage={this.onPage}
        responsive={true} loading={this.state.loading}
        lazy={true} first={this.state.first}
            header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Richieste Supporto</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
              <Button label="Aggiungi" onClick={()=>this.vai(0,'A')} icon="pi pi-plus" className="p-button-rounded p-button-primary "/>
              </div>


              }  
              responsiveLayout="stack">
            <Column id="id0" header="Data"
            
            body={(item) => (
                Moment(new Date(item.datains)).format("DD/MM/yyyy HH:mm:ss")
                )}/>
            <Column id="id1" field="oggetto" header="Oggetto" />
            <Column id="id2" field="descrizione" header="Descrizione" />
            <Column id="id3" field="dettagli" header="Dettagli" />
            {this.utente.ruoloid=='1'||this.utente.ruoloid=='1'?
            <Column id="id4" field="azienda" header="Azienda" />:
            <Column id="id4" header="" />}
            
            <Column id="id4" field="utente" header="Utente" />
            <Column id="ida4" field="stato" header="Stato" />
            <Column id="ida5" field="owner" header="In carico" />
            <Column id="id5"
                field="id"
                header="Azioni"
                body={(item) => (
                    <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                        {this.actions.map((action) => (
                        
                            <Button
                                key={action.id}
                                className="p-button-sm"
                                icon={`pi ${action.icon}`}
                                label={action.label}
                                aria-label={action.label}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.action(item.id);
                                }}
                            />
                        ))}
                        {item.status=='R'?
                           <Button
                           key="99"
                           className="p-button-sm"
                           icon={`pi pi-pencil`}
                           onClick={(e) => {
                               e.stopPropagation();
                               this.vai(item.id,'U');
                           }}
                        />:""
                        }
                    </div>
                )}
            ></Column>
        </DataTable>

        <Dialog header={this.state.intestazione } closable={false} visible={this.state.visible1}  modal style={{ width: '90%' }} draggable={false} resizable={false}>
          
           
            <Formik  initialValues={{ 
                 ownerid:(this.state.singolo.ownerid?this.state.singolo.ownerid:""),
                 noteinterne:(this.state.singolo.noteinterne?this.state.singolo.noteinterne:""),
                 mailrisposta:(this.state.singolo.noteinterne?this.state.singolo.mailrisposta:""),
                 oggetto:(this.state.singolo.oggetto?this.state.singolo.oggetto:""),
                 descrizione:(this.state.singolo.descrizione?this.state.singolo.descrizione:""),
                 dettagli:(this.state.singolo.dettagli?this.state.singolo.dettagli:"")}}
          enableReinitialize
          validationSchema={this.validationSchema}
      
          onSubmit={(values) => {
                this.salva(values);
       }}>
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
         setFieldValue
       }) => (
        <form onSubmit={handleSubmit}>
          <div className="grid formgrid p-fluid">
            <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
             
                <div className=" mb-1 col-2">
                    <label htmlFor="nome" className="font-medium text-600">Oggetto</label>
                    <Dropdown optionLabel="oggetto" options={this.state.listaoggetto}
                    optionValue="oggetto"
                    value={values.oggetto}
                    disabled={this.utente.ruoloid=='1' ||this.utente.ruoloid=='2'}
                    onChange={(e)=>setFieldValue('oggetto',e.value)}
                    placeholder="Seleziona..."/>
               </div>
               <div className=" mb-1 col-4">
                    <label htmlFor="nome" className="font-medium text-600">Utente</label>
                        <InputText disabled="true" value={this.state.singolo.utente}></InputText>
               
               </div>
               <div className=" mb-1 col-4">
                    <label htmlFor="nome" className="font-medium text-600">Azienda</label>
                        <InputText disabled="true" value={this.state.singolo.azienda}></InputText>
               
               </div>
               <div className=" mb-1 col-2">
                    <label htmlFor="nome" className="font-medium text-600">Stato</label>
                        <InputText disabled="true" value={this.state.singolo.stato}></InputText>
               
               </div>
               
                <div className=" mb-1 col-6">
                <label htmlFor="descrizione" className="font-medium text-600">Descrizione</label>
                    <InputTextarea id="descrizione" type="text" disabled={this.utente.ruoloid=='1' ||this.utente.ruoloid=='2'} rows={5} autoResize value={values.descrizione} onChange={handleChange} onBlur={handleBlur}/>
                </div>
                <div className=" mb-1 col-6">
                <label htmlFor="dettagli" className="font-medium text-600">Dettagli</label>
                    <InputTextarea id="dettagli" type="text" disabled={this.utente.ruoloid=='1' ||this.utente.ruoloid=='2'} rows={5} autoResize value={values.dettagli} onChange={handleChange} onBlur={handleBlur}/>
                </div>
                <div className=" mb-1 col-12">
                <label htmlFor="mailrisposta" className="font-medium text-600">Risposta</label>
                    <InputTextarea id="mailrisposta" type="text" 
                    
                    disabled={this.utente.ruoloid=='3' ||this.utente.ruoloid=='4'} 
                    rows={5} autoResize 
                    value={this.state.singolo.status=='C' || this.state.singolo.status=='A' ||  this.utente.ruoloid=='1' || this.utente.ruoloid=='2'?values.mailrisposta:""} onChange={handleChange} onBlur={handleBlur}/>
                </div>
              
                {(this.utente.ruoloid=='1' ||this.utente.ruoloid=='2')?
                <><div className=" mb-1 col-6">
                <label htmlFor="noteinterne" className="font-medium text-600">Note interne</label>
                    <InputTextarea id="noteinterne" type="text" rows={5} autoResize value={values.noteinterne} onChange={handleChange} onBlur={handleBlur}/>
                </div>
          
                <div className=" mb-1 col-3">
                    <label htmlFor="nome" className="font-medium text-600">In carico a</label>
                        <InputText readOnly="true" value={this.state.singolo.owner}></InputText>
               </div>
               <div className=" mb-1 col-3">
                    <label htmlFor="nome" className="font-medium text-600">Creato il </label>
                    {Moment(new Date(this.state.singolo.datains)).format("DD/MM/yyyy HH:mm:ss")}<br/>
                    <label htmlFor="nome" className="font-medium text-600">Ultima modifica il </label>
                    {this.state.singolo.dataupd?Moment(new Date(this.state.singolo.dataupd)).format("DD/MM/yyyy HH:mm:ss"):""}<br/>
                    {this.state.singolo.utenteupdate}

               </div>
               
             
               
              
                </>  
                :""}
        </div>
        <footer>

        <div className="border-top-1 surface-border pt-3">
            
            
            <Button className="mx-2 " visible={this.state.tipo=='A'} icon="pi pi-save" label="Aggiungi" />
            <Button className="mx-2" visible={(this.utente.ruoloid=='1' ||this.utente.ruoloid=='2' ||this.state.singolo.status=='R' )} icon="pi pi-save" label="Salva" />
            <Button className="mx-2 p-button-warning" visible={(this.utente.ruoloid=='1' ||this.utente.ruoloid=='2')} icon="pi pi-save" onClick={()=>this.incarico=true} label="Prendi in carico" />
            <Button className="mx-2 p-button-info" visible={(this.utente.ruoloid=='2')}  icon="pi pi-save" onClick={()=>this.assegnatecnico=true} label="Assegna a Supporto Tecnico" />
            <Button className="mx-2" visible={(this.utente.ruoloid=='3' ||this.utente.ruoloid=='4') && this.state.singolo.status=='C'} icon="pi pi-save" label="Accetta Soluzione" onClick={()=>this.accetta=true}/>
            <Button className="mx-2" visible={(this.utente.ruoloid=='3' ||this.utente.ruoloid=='4') && this.state.singolo.status=='C'} icon="pi pi-save" label="Riapri Segnalazione"  onClick={()=>this.riapri=true}/>
            <Button className="mx-2 p-button-success" visible={(this.utente.ruoloid=='1' ||this.utente.ruoloid=='2')} icon="pi pi-save" label="Pubblica Risoluzione"  onClick={()=>this.risolto=true}  />
            <Button type="button" icon="pi pi-check" onClick={() => this.setVisible1(false)} label="Chiudi" />
            </div>
        </footer>
        </form>
        )}                   
           </Formik>
        
        </Dialog>
        </div>
     
    );
   }
};

export default Supporto;
